const finishFaqTransition = (panel, item, isOpen) => {
  let isFinished = false;
  let fallbackTimer;

  const complete = () => {
    if (isFinished) {
      return;
    }

    isFinished = true;
    panel.removeEventListener('transitionend', onTransitionEnd);
    window.clearTimeout(fallbackTimer);
    item.classList.remove('faq__item--animating');

    if (isOpen) {
      panel.style.height = 'auto';
      return;
    }

    panel.hidden = true;
  };

  const onTransitionEnd = (event) => {
    if (event.target !== panel || event.propertyName !== 'height') {
      return;
    }

    complete();
  };

  panel.addEventListener('transitionend', onTransitionEnd);
  fallbackTimer = window.setTimeout(complete, 360);
};

const openFaqItem = (item) => {
  const button = item.querySelector('.js-faq-question');
  const panel = item.querySelector('.js-faq-panel');

  if (!button || !panel || item.classList.contains('faq__item--open')) {
    return;
  }

  panel.hidden = false;
  panel.style.height = '0px';
  item.classList.add('faq__item--open', 'faq__item--animating');
  button.setAttribute('aria-expanded', 'true');

  window.requestAnimationFrame(() => {
    finishFaqTransition(panel, item, true);
    panel.style.height = `${panel.scrollHeight}px`;
  });
};

const closeFaqItem = (item) => {
  const button = item.querySelector('.js-faq-question');
  const panel = item.querySelector('.js-faq-panel');

  if (!button || !panel || !item.classList.contains('faq__item--open')) {
    return;
  }

  panel.style.height = `${panel.scrollHeight}px`;
  item.classList.add('faq__item--animating');
  button.setAttribute('aria-expanded', 'false');

  window.requestAnimationFrame(() => {
    finishFaqTransition(panel, item, false);
    item.classList.remove('faq__item--open');
    panel.style.height = '0px';
  });
};

const toggleFaqItem = (item) => {
  if (item.classList.contains('faq__item--open')) {
    closeFaqItem(item);
    return;
  }

  openFaqItem(item);
};

export const initFaq = () => {
  const faqItems = document.querySelectorAll('.js-faq-item');

  faqItems.forEach((item) => {
    const button = item.querySelector('.js-faq-question');
    const panel = item.querySelector('.js-faq-panel');
    const isOpen = item.classList.contains('faq__item--open');

    if (!button || !panel) {
      return;
    }

    button.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      panel.hidden = false;
      panel.style.height = 'auto';
    } else {
      panel.hidden = true;
      panel.style.height = '0px';
    }

    button.addEventListener('click', () => toggleFaqItem(item));
  });
};
